import * as React from 'react';
import { useState } from 'react';
import { DirectoryRaterViewModelProps } from './props';
import LocalDiv from '../../../../localization/LocalDiv';
import { FLEX_COLUMN, FLEX_ROW } from '../../../../layout/flexBox';
import Msg from '../../../../localization/Msg';
import { lastCommaFirstLocal } from '../module';
import LocalSelect from '../../../../localization/LocalSelect';
import { SELECT } from '../../../../forms/styles/select';
import { css } from '@emotion/core';
import { COLORS } from '../../../../globalStyle/colors';
import LocalDropdownOption from '../../../../localization/LocalDropdownOption';
import { Str } from '../../../../localization/translationKeys';
import LocalBtn from '../../../../localization/LocalBtn';
import { btnStyle } from '../../../../forms/styles/button';
import { RaterLevel } from '../models';
import Spacer from '../../../../layout/Spacer';


const styles = {
  root: css`
  `,
  infoAndButton:     {
    root:      css`
    justify-content: space-between;
    `,
    raterInfo: css`
      &[dir="ltr"] {
        text-align: left;
      }

      &[dir="rtl"] {
        text-align: right;
      }
    `,
    button:    css`
      padding-left: 12px;
      padding-right: 12px;
    `,
  },
  dropdownContainer: {
    root:     css`
      align-content: stretch;
    `,
    dropdown: css`
      border-color: ${COLORS.WHITE};
    `,
  },
};


type Props = DirectoryRaterViewModelProps;


const renderRaterLevelOptions = (levels: RaterLevel[]) => levels.map(
  level => (
    <LocalDropdownOption
      key={level.surveyLevelId}
      value={level.surveyLevelId}
      labelKey={''}
      labelText={level.fullName}
    />
  ),
);


/**
 * RaterSearchCard: a component that
 *
 * PureComponent: true
 * Redux Connected: false
 */
const RaterSearchCard: React.FC<Props> = props => {
  const [levelId, setLevelId] = useState<number | undefined>(undefined);

  const onClickSubmitBtn = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();
    props.setAddedRater(levelId!);
  };

  return (
    <LocalDiv className={props.className}>
      <LocalDiv css={[FLEX_COLUMN, styles.root]}>
        <LocalDiv css={[FLEX_ROW, styles.infoAndButton.root]}>
          <LocalDiv css={[FLEX_COLUMN, styles.infoAndButton.raterInfo]}>
            <Msg str='' defaultMsg={lastCommaFirstLocal(props.dir, props.rater) || '---'} />
            <Msg str='' defaultMsg={props.rater.email} />
          </LocalDiv>
          <LocalBtn
            str={Str.Add}
            css={[btnStyle.primary(COLORS.DARK_GREY), styles.infoAndButton.button]}
            disabled={!levelId}
            onClick={onClickSubmitBtn}
          />
        </LocalDiv>
        <Spacer sizePx={4} />
        <LocalDiv css={styles.dropdownContainer.root}>
          <LocalSelect
            css={[SELECT, styles.dropdownContainer.dropdown, !levelId && css`color: ${COLORS.FIELD_GREY};`]}
            onChange={event => setLevelId(+event.target.value)}
            value={levelId}
          >
            {
              !levelId && (
                <LocalDropdownOption labelKey={Str.SelectOne} hidden={true} value='' />
              )
            }
            {renderRaterLevelOptions(props.raterLevels)}
          </LocalSelect>
        </LocalDiv>
      </LocalDiv>
    </LocalDiv>
  );
};

export default RaterSearchCard;
